export var clsPrefix = 'cn-ui-m-input';
